import { Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import clsx from 'clsx';
import React from 'react';

interface Props {
	status: string | undefined;
	className: string;
}

export const BadgeDetail: React.FC<Props> = ({ status, className }) => {
	const isClosed = status?.startsWith('Closed');
	let icon = Icons.checkCircle;

	if (isClosed) {
		icon = Icons.closeCircle;
	}

	return (
		<div
			className={clsx(
				'rounded-xl h-8 flex items-center gap-2 p-2',
				{
					'bg-[#FF004314]': isClosed,
					'bg-green-140': !isClosed,
				},
				className
			)}
		>
			<Icon
				src={icon}
				className={clsx('!size-[14px] !text-primary', {
					'!text-main-red': isClosed,
				})}
			/>
			<Typography type="semibold-12">{status}</Typography>
		</div>
	);
};
